import styled from 'styled-components';
import NumberInput from '../NumberInput/NumberInput';

export const NormInput = styled(NumberInput)`
  width: 120px;
`;

export const WarningCircle = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background: #ffa39e;
`;
